import { EXPERIMENT_ID_PREFIXES } from 'chimera/all/constants/experiments'
import { EventBus } from 'chimera/all/plugins/eventbus'
import { createScopedEvent } from 'chimera/all/plugins/tracking/google/events/analytics/index'
import {
  getDynamicEventScopeValue,
  setDynamicEventScopeValue,
} from 'chimera/all/plugins/eventbus/scope'
import { GoogleAnalyticsCustomDimension } from 'chimera/all/plugins/tracking/google/constants'

const SHORT_CODE_PATTERN = new RegExp(
  `^(SG:)((?:${EXPERIMENT_ID_PREFIXES.join('|')})-\\d+)[^:]*(:.*)`,
  'i',
)

/**
 * Derive shortCode from experiment code for Google Analytics.
 * Extracts ticket ID only: SG:pd-9725_-_aa_experiment:0:1 → SG:PD-9725:0:1
 * @param {string} code - Full experiment code
 * @returns {string}
 */
function getShortCode(code) {
  const match = code.match(SHORT_CODE_PATTERN)
  if (match) {
    return `${match[1]}${match[2]}${match[3]}`.toUpperCase()
  }
  return code.toUpperCase()
}

/**
 * Sets the experiment-id dimension which will be sent along with all future hits.
 * Derives shortCode (with ticket ID only) to keep GA dimension values short.
 *
 * @param {object} Vue
 * @param {object} event
 * @param {object} event.scope
 * @param {object} event.experiment - Experiment object with code property
 * @param {string} event.experiment.code
 */
export function setExperimentCustomDimension(
  Vue,
  { scope, experiment: { code } },
) {
  const shortCode = getShortCode(code)

  if (shortCode.match(/,/)) {
    EventBus.emitWarningAppErrorEvent(
      new Error(
        `Experiment code ${shortCode} has a comma(,) in it. This is not allowed.`,
      ),
      {
        code: shortCode,
      },
    )
  }

  const dimension = GoogleAnalyticsCustomDimension.EXPERIMENT_EXPOSURE.name
  const current = getDynamicEventScopeValue(dimension)
  const exposures = current ? current.split(',') : []

  if (!exposures.includes(shortCode)) {
    exposures.push(shortCode)
    setDynamicEventScopeValue(dimension, exposures.join(','))
  }

  Vue.$gtag.event(
    'experiment',
    createScopedEvent(scope, {
      code: shortCode,
    }),
  )
}
